import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfileContractTermsRequest } from '@/shared/api/requests/club/contract-terms/get/request';
import { getClubProfileContractTerms } from '@/shared/api/requests/club/contract-terms/get/request';

export const useClubProfileContractTermsQuery = (
  params: GetClubProfileContractTermsRequest,
  settings?: QuerySettings<typeof getClubProfileContractTerms>
) =>
  useQuery({
    queryKey: ['ClubProfileContractTerms', params.clubId],
    queryFn: () =>
      getClubProfileContractTerms({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
